/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var EmptyComputerIcon = createIcon("EmptyComputerIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "120",
    height: "120",
    viewBox: "0 0 120 120",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M60 120c33.137 0 60-26.863 60-60S93.137 0 60 0 0 26.863 0 60s26.863 60 60 60Z",
    fill: "#CFCEFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".35",
    d: "M24 47.5h56a1.5 1.5 0 011.5 1.5v34.333a1.5 1.5 0 01-1.5 1.5H24a1.5 1.5 0 01-1.5-1.5V49a1.5 1.5 0 011.5-1.5Z",
    fill: "#A5AEFF",
    stroke: "#A5AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".35",
    d: "M38.25 92.667h27.5",
    stroke: "#A5AEFF",
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".35",
    d: "M49.167 84.5h5.666v6.667h-5.666V84.5Z",
    fill: "#A5AEFF",
    stroke: "#A5AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88 40a.997.997 0 011 1v34.333a.996.996 0 01-1 1H32a.997.997 0 01-1-1V41a.997.997 0 011-1h56Z",
    fill: "#fff",
    stroke: "#0C0D0D",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 43h50l-17.803 2.746A41.494 41.494 0 0034 71.333V43Z",
    fill: "#CFCEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.25 84.667h27.5",
    stroke: "#0C0D0D",
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.333 76.333h-6.666V84h6.666v-7.667Z",
    fill: "#0C0D0D"
  }));
}, {
  "i18nKey": "svg.EmptyComputerIcon"
});